var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.216V3.906C6.50013 3.53306 6.64838 3.17544 6.91213 2.91178C7.17589 2.64812 7.53356 2.5 7.9065 2.5H20.0935C20.4665 2.5 20.8243 2.64818 21.088 2.91195C21.3518 3.17572 21.5 3.53347 21.5 3.9065V16.094C21.4999 16.4669 21.3517 16.8244 21.088 17.088C20.8244 17.3517 20.4669 17.4999 20.094 17.5H17.758",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.094 6.5H3.9055C3.53265 6.50027 3.17515 6.64857 2.9116 6.91231C2.64805 7.17605 2.5 7.53365 2.5 7.9065V20.0935C2.5 20.4665 2.64818 20.8243 2.91195 21.088C3.17572 21.3518 3.53347 21.5 3.9065 21.5H16.094C16.4669 21.4999 16.8244 21.3517 17.088 21.088C17.3517 20.8244 17.4999 20.4669 17.5 20.094V7.9055C17.4997 7.53273 17.3515 7.17532 17.0879 6.91178C16.8242 6.64824 16.4668 6.50013 16.094 6.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.e54ef5f9d522aa41a852410ce8c1efcc.svg";
export { ForwardRef as ReactComponent };